module.exports = __webpack_public_path__ + "static/media/7Z.4babcf36.svg";